import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CardWidgetV2: WidgetRegistryEntry = {
  name: "CardV2",
  configuration: () => import("./configuration").then((m) => m.CardWidgetConfiguration),
  component: () => import("./card-widget-v2.component").then((m) => m.CardWidgetV2Component)
};
